import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import InfiniteScrollList from "../../../../../components/Forms/ListView/InfiniteScrollList";
import { MasterConfigs } from "../../../../../interfaces/entity";
import FormSetup from "../../../../../components/Forms/FormSetup";
import { Button, Space, Modal, notification } from "antd";
import { DownOutlined, UpOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
import useToggle from "../../../../../hooks/useToggle";
import { deleteRow } from "../../../../../actions/apiCall";
import CommonView, { CommonViewProps } from "../../../../../components/CommonView/CommonView";

const Reviewer = () => {
    const [open, setOpen] = useState(false);
    const [refresh, setRefresh] = useState(false);
    const formRef = React.useRef(null);
    const [selectedId, setSelectedId] = useState<string | null>(null);
    const [editId, setEditId] = useState(null);

    const { toggle, isExpanded } = useToggle();
    const dispatch = useDispatch();

    useEffect(() => {
        if (selectedId) {
            setRefresh(true)
        }
    }, [selectedId])

    const handleOpenModal = (id = null, editId = null) => {
        setSelectedId(id);
        setEditId(editId || null);
        setOpen(true);
    };
    const handleDelete = async (id) => {
        Modal.confirm({
            title: "Are you sure ?",
            content: "Do you want to delete this record ?",
            okText: "Yes, Delete",
            cancelText: "Cancel",
            onOk: async () => {
                const response = await dispatch(deleteRow(`/probation-feedback-form/${id}`));
                if (response.code !== 0) {
                    notification.success({ message: 'Record deleted successfully' })
                    setRefresh(true);
                } else {
                    console.log("Something went wrong");
                }
            },
        });
    };

    const departmentConfig: MasterConfigs = {
        api: () => '/departments',
        modalTitle: () => 'Departments',
        onRefresh: () => {
            setRefresh(true)
        },
        getFormColumns: () => [
            {
                label: 'Name',
                name: 'name',
                type: 'text',
                rules: [{ required: true, message: 'Please enter Skill name' }]
            },
            {
                label: 'Description',
                name: 'description',
                type: 'textarea',
                span: 18,
            },
        ],
    }

    const componentConfig: CommonViewProps = {
        config: departmentConfig,
        listProps: {
            reload: refresh,
            onLoaded: () => {
                setRefresh(false)
            }
        },
        componentConfig: {
            title: "Department",
            subTitle: "",
            cardTitle: "Departments",
            buttonName: "Add Department",
            emptyDescription: "No Questions found",
            renderComponent: (record: any) =>
                <>
                    <div className="flex justify-end">
                        <Button type="primary" onClick={() => handleOpenModal(record._id)}>
                            Add Question
                        </Button>
                    </div>
                    <InfiniteScrollList
                        apiUrl={`/probation-feedback-form?formFor=Reviewer&department=${selectedId}`}
                        reload={refresh}
                        onLoaded={() => setRefresh(false)}
                        renderItem={(item) => (
                            <Space direction="vertical" className="relative w-full p-4 border border-gray-200 rounded-md mb-4 relative">
                                <div className="flex justify-between items-center">
                                    <p className="text-black font-semibold text-lg">{item?.question}</p>
                                    <div className="flex gap-2">
                                        <Button type="link">
                                            <EditOutlined className="text-gray-500 hover:text-gray-700 cursor-pointer"
                                                onClick={() => handleOpenModal(selectedId, item._id)}
                                            />
                                        </Button>
                                        <Button type="link" danger>
                                            <DeleteOutlined
                                                onClick={() => handleDelete(item._id)}
                                            />
                                        </Button>
                                    </div>
                                </div>
                                <Space direction="horizontal" onClick={() => toggle(item._id)}>
                                    <Button type="text" icon={isExpanded(item._id) ? <UpOutlined /> : <DownOutlined />}>
                                        {isExpanded(item._id) ? "Show Less" : "Show More"}
                                    </Button>
                                </Space>

                                {isExpanded(item._id) && (
                                    <Space direction="horizontal" className="mt-2">
                                        {item?.options?.map((option, index) => (
                                            <div key={index} className="mr-4">
                                                <p>
                                                    <strong>Option {String.fromCharCode(65 + index)}</strong> - {option?.percentage}%
                                                </p>
                                                <h4>{option.option}</h4>
                                                <h4 className="text-black font-semibold">{option?.answer}</h4>
                                            </div>
                                        ))}
                                    </Space>
                                )}
                            </Space>
                        )}
                    />
                </>,
            renderListItem: (record: any) => record.name,
            selectedItemId: (id) => setSelectedId(id),
        }
    }


    const config: MasterConfigs = {
        api: () => "/probation-feedback-form",
        apiParams: { formFor: "Reviewer", department: selectedId },
        onRefresh: () => setRefresh(true),
        modalTitle: () => "Probation Feedback",
        title: "Probation Feedback",
        getFormColumns: () => [
            {
                label: "Question",
                name: "question",
                type: "textarea",
                span: 24,
                rules: [{ required: true, message: "Please enter the question" }],
            },
            {
                type: "form",
                name: "options",
                span: 24,
                form: [
                    { label: "Percentage", name: "percentage", type: "text", rules: [{ required: true, message: "Please enter a percentage" }], },
                    { label: "Option", name: "option", type: "text", rules: [{ required: true, message: "Please enter an option" }] },
                ],
            },
        ],
    };

    return (
        <>
            <FormSetup open={open} config={config} onClose={() => setOpen(false)} isModal={true} form={(formInstance) => (formRef.current = formInstance)} id={editId} />
            <CommonView componentConfig={componentConfig.componentConfig} config={componentConfig.config} />
        </>
    );
};

export default Reviewer;
